import { useTradeModule } from '../TradeModuleCtx';

/**
 *
 * Gas calculation
 *
 * estimateGasLimit : TradingPortalFacet.estimateGas.openMarketTrade
 *
 * gasPrice * estimateGasLimit = estFeeInNativeTokenAmount
 *
 * estFeeInUsd = estFeeInNativeTokenAmount * nativeTokenPrice
 *
 */
// native token
export const useEstOpenPositionGasFee = ({
  disabled,
}: {
  disabled: boolean | undefined;
}) => {
  const { openPositionGasFee } = useTradeModule();
  if (disabled) {
    return undefined;
  }
  
return openPositionGasFee;
};